import { Affix, Button, Card, Spin } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";

import AddUnitsPriceFormModal from "./AddUnitsPriceFormModal";
import { postData } from "apiServices/common";
import { PO_WISE_INFO } from "apiServices/API_ENDPOINTS";
import { isArrayAndHasValue } from "utils/functions";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";


export default function UpdatePOWiseBreakdownModal(props) {
  // Props
  const { width, itemId, poMapId } = props;

  // States
  const [permitInfo, setPermitInfo] = useState();
  const [poDetailsData, setPoDetailsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Others
//   const { itemId, poMapId } = useParams();
  const propertyFormRef = useRef(null);

  const addProduct = () => {
    propertyFormRef.current.submit();
  };

  const getPOInfo = useCallback(async () => {
    if (!poMapId) {
      console.error("po_map_id is required");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const payload = {
      id: parseInt(itemId),
      po_map_id: parseInt(poMapId),
    };

    try {
      const response = await postData(PO_WISE_INFO, payload);
      // console.log(response, "response");
      if (response && response?.code === 200) {
        const masterData = response.data;
        setPermitInfo(masterData);
        const po_data = masterData ? masterData.unit_price_details : null;

        const po_details =
          isArrayAndHasValue(po_data) &&
          po_data.map((item) => {
            const sizes = {};

            item?.sizes.forEach((size) => {
              sizes[size?.name + "_" + size?.id] = size?.sales_order_quantity;
            });
            return {
              ...item,
              style_id: item.style.id,
              color_id: item.color.id,
              ...sizes,
              isManuallyAdded: false,
            };
          });

        setPoDetailsData(po_details || []);
      }
    } catch (error) {
      console.error("Error fetching PO info:", error);
    } finally {
      setIsLoading(false);
    }
  }, [itemId, poMapId]);

  useEffect(() => {
    if (itemId && poMapId) {
      getPOInfo();
    } else {
      setIsLoading(false);
    }
  }, [itemId, poMapId, getPOInfo]);

  // console.log(poDetailsData, "poDetailsData");
  // console.log(permitInfo, "permitInfo");

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "90vh",
          backgroundColor: "#fff",
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  return (
    <>
      

      <AddUnitsPriceFormModal
        ref={propertyFormRef}
        permitInfo={permitInfo}
        poDetailsData={poDetailsData}
        setPoDetailsData={setPoDetailsData}
        mode="view"
      />
    </>
  );
}
